import './interface/styling/main.scss';
import './data/utils/helpers';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AppLoader } from './app-loader';
import { AppContext } from './data/context/app-context';
import { AlertMessage } from './elements/alert-message/alert-message';
import { Footer } from './elements/footer/footer';
import { Header } from './elements/header/header';
import { Spinner } from './elements/spinner/spinner';
import { AuthStatus } from './firebase/authentication';
import { IntlLoader } from './intl-loader';
import { AdminPage } from './pages/admin/admin';
import { AdminFeaturesPage } from './pages/admin/features/admin-features';
import { AdminGlobalTranslationsPage } from './pages/admin/global-translations/admin-global-translations';
import { AdminHealthProfessionalsPage } from './pages/admin/health-professionals/admin-health-professionals';
import { AdminHealthProviderTranslationsPage } from './pages/admin/health-provider-translations/admin-health-provider-translations';
import { AdminHonorificBlockTimesPage } from './pages/admin/honorific-block-times/honorific-block-times';
import { AdminOpeningHoursPage } from './pages/admin/opening-hours/admin-opening-hours';
import { AdminTemplatesPage } from './pages/admin/templates/admin-templates';
import { AgendaPage } from './pages/agenda/agenda';
import { Auth } from './pages/authentication/auth/auth';
import { BulkMessagesPage } from './pages/bulk-messages/bulk-messages';
import { ConversationsPage } from './pages/conversations/conversations';
import { PatientsPage } from './pages/patients/patients';
import { RemindersPage } from './pages/reminders/reminders';
import { SchedulePage } from './pages/schedule/schedule';

export function App() {
  // const [locale] = useLocalState<string>('language', 'nl');

  return (
    <IntlLoader locale="nl">
      <BrowserRouter>
        <AppLoader>
          <AppContext.Consumer>
            {({
              initialized,
              status,
              user,
              alertMessages,
              hideAlertMessage,
            }) => (
              <>
                {alertMessages.map(option => (
                  <AlertMessage
                    {...option}
                    key={option.id}
                    onClose={() => hideAlertMessage(option.id ?? '')}
                  />
                ))}

                <div className="app">
                  {initialized ? (
                    <>
                      {status?.status === AuthStatus.AUTHORIZED ? (
                        <>
                          <Header />
                          <main className="main">
                            <Routes>
                              <Route path=":healthProviderId">
                                <Route path="agenda">
                                  <Route
                                    path=":healthProfessionalId?/:date?"
                                    element={<AgendaPage />}
                                  />
                                </Route>

                                <Route path="conversations">
                                  <Route
                                    path=":conversationId?"
                                    element={<ConversationsPage />}
                                  />
                                </Route>

                                <Route path="reminders">
                                  <Route
                                    path=":group?"
                                    element={<RemindersPage />}
                                  />
                                </Route>

                                <Route
                                  path="bulk-messages"
                                  element={<BulkMessagesPage />}
                                />

                                <Route path="patients">
                                  <Route
                                    path=":group?"
                                    element={<PatientsPage />}
                                  />
                                </Route>

                                <Route path="schedule">
                                  <Route
                                    path=":healthProfessionalId?/:year?/:weekNr?"
                                    element={<SchedulePage />}
                                  />
                                </Route>

                                {user?.isAdmin && (
                                  <Route path="admin" element={<AdminPage />}>
                                    <Route
                                      path="users"
                                      element={<AdminHealthProfessionalsPage />}
                                    />

                                    <Route
                                      path="templates"
                                      element={<AdminTemplatesPage />}
                                    />

                                    <Route
                                      path="honorific-block-times"
                                      element={<AdminHonorificBlockTimesPage />}
                                    />
                                    <Route
                                      path="opening-hours"
                                      element={<AdminOpeningHoursPage />}
                                    />
                                    <Route
                                      path="health-provider-translations"
                                      element={
                                        <AdminHealthProviderTranslationsPage />
                                      }
                                    />
                                    <Route
                                      path="features"
                                      element={<AdminFeaturesPage />}
                                    />
                                    <Route
                                      path="global-translations"
                                      element={<AdminGlobalTranslationsPage />}
                                    />
                                  </Route>
                                )}

                                <Route
                                  path=""
                                  element={<ConversationsPage />}
                                />
                              </Route>
                            </Routes>
                          </main>

                          {import.meta.env.VITE_DEBUG !== 'false' && <Footer />}
                        </>
                      ) : (
                        <Auth />
                      )}

                      <div id="portal-container" />
                      <div id="alert-messages-container" />
                    </>
                  ) : (
                    <div className="page-loader">
                      <Spinner />
                    </div>
                  )}
                </div>
              </>
            )}
          </AppContext.Consumer>
        </AppLoader>
      </BrowserRouter>
    </IntlLoader>
  );
}
